module.exports = __webpack_public_path__ + "static/img/ngzg_new.f3a35e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ngzg_new.jpg
// module id = Pi3a
// module chunks = 3